<template>
  <div class="school-intro">
    <h1>院校介绍</h1>
    <div class="service-category">留学服务</div>

    <section class="intro-section">
      <h2>一、加拿大大学的类别划分</h2>
      <div class="category-content">
        <p>加拿大高等教育在全世界处于先进水平，其教育质量受到全世界的广泛认可。一方面归功于一流的教育质量，另一方面归功于公立教育体制，因为加拿大的高等院校几乎都是公立的。在教育资源配置以及发展程度上都受到了政府的极大重视和支持。加拿大著名的Maclean’s杂志在大学排名时，根据学校专业设置将加拿大的大学分为三类：分别为医博类大学(Medical & Doctoral)、综合类大学(Comprehensive)、和基础类大学(Primarily undergraduate)。</p>
        
        <h3>1. 医博类大学(Medical &Doctoral)</h3>
        <p>医博类大学指大型的研究型大学，可以提供绝大部分学科专业博士学位(包括医学)的研究型大学。而医学博士学位是需要较高综合实力的大学才开设的，故“医博类大学”即为加拿大研究实力最顶尖的大学。</p>

        <h3>2. 综合类大学(Comprehensive category)</h3>
        <p>综合类大学提供本科和研究生课程及专业学位，是开展大量学术研究的大学。</p>

        <h3>3. 基础类大学(Primarily undergraduate)</h3>
        <p>基础类大学指那些专注于本科教育的大学。这类大学很少开设研究生博士专业的课程。这类大学教学质量与前两类大学同质，只是教学规模不及医博类和综合类大学。</p>
      </div>

      <h2>二、加拿大的大学分布情况</h2>
      <div class="faculty-list">
        <h3>BC省的主要大学有：</h3>
        <ul>
          <li>英属哥伦比亚大学</li>
          <li>维多利亚大学</li>
          <li>西蒙菲莎大学</li>
          <li>汤姆逊河大学</li>
          <li>皇家大学</li>
          <li>温哥华岛大学</li>
          <li>北不列颠哥伦比亚大学等</li>
        </ul>

        <h3>安大略省的主要大学有：</h3>
        <ul>
          <li>多伦多大学</li>
          <li>麦克马斯特大学</li>
          <li>皇后大学</li>
          <li>滑铁卢大学</li>
          <li>约克大学</li>
          <li>西安大略大学</li>
          <li>渥太华大学</li>
          <li>卡尔顿大学</li>
          <li>圭尔夫大学等</li>
        </ul>

        <h3>魁北克省的主要大学有：</h3>
        <ul>
          <li>麦吉尔大学</li>
          <li>蒙特利尔大学</li>
          <li>魁北克大学</li>
          <li>拉瓦尔大学</li>
          <li>康考迪亚大学</li>
          <li>毕索大学等</li>
        </ul>

        <h3>阿尔伯塔省的主要大学：</h3>
        <ul>
          <li>阿尔伯塔大学</li>
          <li>卡尔加里大学</li>
        </ul>

        <h3>萨斯喀彻温省的主要大学：</h3>
        <ul>
          <li>萨斯喀彻温大学等</li>
        </ul>

        <h3>曼尼托巴省的主要大学：</h3>
        <ul>
          <li>曼尼托巴大学等</li>
        </ul>

        <h3>纽芬兰与拉布拉多省的主要大学：</h3>
        <ul>
          <li>纽芬兰纪念大学等</li>
        </ul>

        <h3>新不伦瑞克省的主要大学：</h3>
        <ul>
          <li>新不伦瑞克大学</li>
          <li>蒙克顿大学</li>
          <li>圣托马斯大学</li>
        </ul>

        <h3>爱德华王子岛省的主要大学：</h3>
        <ul>
          <li>爱德华王子岛大学等</li>
        </ul>

        <h3>新斯科舍省的主要大学：</h3>
        <ul>
          <li>达尔豪斯大学</li>
          <li>圣文森特山大学</li>
          <li>圣玛丽大学</li>
          <li>圣西维尔大学等</li>
        </ul>


      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SchoolIntroView'
}
</script>

<style scoped lang="less">
.school-intro {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    font-size: 32px;
    color: #333;
    margin-bottom: 10px;
  }

  .service-category {
    color: #666;
    font-size: 18px;
    margin-bottom: 30px;
  }

  .intro-section {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    h2 {
      font-size: 24px;
      color: #333;
      margin: 30px 0 20px;
      
      &:first-child {
        margin-top: 0;
      }
    }

    h3 {
      font-size: 18px;
      color: #444;
      margin: 20px 0 10px;
    }

    p {
      line-height: 1.8;
      color: #555;
      margin-bottom: 15px;
    }

    .faculty-list {
      ul {
        list-style: none;
        padding: 0;
        margin-bottom: 25px;

        li {
          padding: 10px 15px;
          background: #f8f9fa;
          margin-bottom: 8px;
          border-radius: 4px;
          color: #555;
          transition: all 0.3s ease;

          &:hover {
            background: #e9ecef;
            transform: translateX(10px);
          }
        }
      }
    }
  }
}
</style>